// components/TestimonialSlider.jsx
import { useTranslations } from 'next-intl';
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const TestimonialSlider = () => {
  const t = useTranslations('home.reviews.slides');

  const testimonials = [
    { text: t('0.review'), author: t('0.name') },
    { text: t('1.review'), author: t('1.name') },
    { text: t('2.review'), author: t('2.name') },
    { text: t('3.review'), author: t('3.name') }
  ];

  return (
    <div className="border-l-[5px] border-l-[#EAAC00] py-3 bg-[#F1E8C5B8] px-4 md:px-7 flex items-center">
      <Swiper
        modules={[Navigation, Autoplay]}
        loop={true}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          reverseDirection: true,
        }}
        slidesPerView={1}
        className="testimonial-slider"
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="italic text-[#000] text-[14.5px] leading-[18px] mb-1">
              "{item.text}"
            </div>
            <div className="text-[#000] text-[14.5px] leading-[18px]">
              – {item.author}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialSlider;